var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPointOfSale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "#E5F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37.9133H39.0029",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7815 27.7793V37.9135",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31.001H34.0013V34.0022H32.0004",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.58 27.7835C31.153 27.7835 29.9962 26.6267 29.9962 25.1997C29.9962 26.627 28.8391 27.784 27.4119 27.784C25.9846 27.784 24.8276 26.627 24.8276 25.1997C24.8255 26.6252 23.6692 27.7796 22.2438 27.7795V27.7795C21.4609 27.7795 20.7342 27.3728 20.3247 26.7056C19.9152 26.0383 19.8818 25.2062 20.2363 24.5082L21.9725 21.0908C22.3138 20.4192 23.0034 19.9961 23.7568 19.9961H36.2355C36.9889 19.9961 37.6784 20.4192 38.0197 21.0908L39.756 24.5083C40.1105 25.2063 40.077 26.0383 39.6676 26.7056C39.2581 27.3729 38.5314 27.7795 37.7486 27.7795V27.7795V27.7835V27.7835C37.0633 27.7836 36.4061 27.5113 35.9215 27.0268C35.437 26.5422 35.1647 25.885 35.1647 25.1997C35.1625 26.6255 34.0058 27.7801 32.58 27.7795",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9922 33.5017V37.0032C19.9922 37.97 20.776 38.7538 21.7429 38.7539H27.2452C28.2121 38.7538 28.9959 37.97 28.9959 37.0032V33.5017C28.9959 32.5348 28.2121 31.751 27.2452 31.751H21.7429C20.776 31.751 19.9922 32.5348 19.9922 33.5017V33.5017Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9959 34.8635H19.9922",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPointOfSale);
export default __webpack_public_path__ + "static/media/icon_point-of-sale.77ea0e2784a46087d279df0ab09486da.svg";
export { ForwardRef as ReactComponent };